export const SET_ONBOARDING_DATA = 'SET_ONBOARDING_DATA';

export const setOnboardingData = (data) => ({
  type: SET_ONBOARDING_DATA,
  payload: data,
});
